import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Form,
  Modal,
  Button,
  TextInput,
  HoursInput,
  ButtonsWrapper,
} from '@thinknet-gmbh/platform-common-ui';

import { ITimeStripeGanttFormModal } from './time-stripe-gantt-form-modal.interfaces';

const TimeStripeGanttFormModal = ({
  onClose,
  timeStripe,
  onSubmitTimeStripeModal,
}: ITimeStripeGanttFormModal) => {
  const { t } = useTranslation(['employee', 'common', 'projects']);
  const [form] = Form.useForm();

  useEffect(() => form.setFieldsValue(timeStripe), [form, timeStripe]);

  return (
    <Modal isOpened onClose={onClose} title={t('projects:labels.editTimeStripe')}>
      <Form layout="vertical" form={form} onFinish={onSubmitTimeStripeModal}>
        <Form.Item
          name="name"
          label={t('projects:task.timeStripeName')}
          rules={[
            {
              required: true,
              message: t('projects:validation.timeStripeNameRequired'),
            },
          ]}
        >
          <TextInput placeholder={t('projects:task.timeStripeName')} />
        </Form.Item>

        <Form.Item
          name="plannedHours"
          label={t('projects:labels.plannedHours')}
          rules={[
            {
              required: true,
              message: t('projects:validation.plannedHoursRequired'),
            },
          ]}
        >
          <HoursInput placeholder="10 hr" maxValue={10000} />
        </Form.Item>

        <ButtonsWrapper marginTop={16}>
          <Button type="primary" htmlType="submit">
            {t('common:buttons.save')}
          </Button>
          <Button onClick={onClose}>{t('common:buttons.cancel')}</Button>
        </ButtonsWrapper>
      </Form>
    </Modal>
  );
};

export default TimeStripeGanttFormModal;
